<top-banner variant="title" [title]="selectedAsset ? selectedAsset.site.name + ' - ' + selectedAsset.name : ''"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2 row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <div *ngIf="!loaded" class="progress-spinner-wrapper">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <ng-container *ngIf="loaded">
              <h4 class="card-title">Schedule History</h4>
              <div class="mb-2 animated fadeIn">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From</label>
                      <p-calendar class="form-control" [(ngModel)]="fromDate" appendTo="body" (ngModelChange)="onFromDateChange($event)" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>To</label>
                      <p-calendar class="form-control" [(ngModel)]="toDate" appendTo="body" (ngModelChange)="onToDateChange($event)" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">

                    <p-table
                      [autoLayout]="true"
                      [value]="availabilityItems"
                    >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Note</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-availabilityItem>
                      <tr>
                        <td>
                          {{ availabilityItem.startTime | date: 'dd/MM/yy - EEEE - HH:mm' }}
                        </td>
                        <td>
                          {{ availabilityItem.endTime | date: 'dd/MM/yy - EEEE - HH:mm' }}
                        </td>
                        <td>
                          {{ availabilityItem.reason }}
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="3">No schedules created</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="card-footer" [ngStyle]="{display: availabilityItems.length ? '' : 'none'}">
            <p-paginator #paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>

